export default __webpack_public_path__ + "static/media/meat.3785a301.png";